import { Client } from 'projects/access-control/src/app/Domain/Entities/client.interface';
import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
export const CLIENTS_STATE_NAME = 'client';

export interface ClientState {
	clients: Client[];
	pagination: Pagination;
	error: any;
	loading: boolean;
	loadingModule: boolean;
}

export const initialStateModule: ClientState = {
	clients: [],
	pagination: {} as Pagination,
	error: null,
	loading: false,
	loadingModule: false,
};
